import { useEffect, useState } from "react";
import { getNookClient } from "../client.js";
const DEBOUNCE_MS = 150;
export function useSearchStream(query, limit = 8) {
    const [results, setResults] = useState([]);
    const [status, setStatus] = useState("idle");
    useEffect(() => {
        const trimmed = query.trim();
        if (!trimmed) {
            setResults([]);
            setStatus("idle");
            return;
        }
        const controller = new AbortController();
        const timer = setTimeout(async () => {
            setStatus("loading");
            let first = true;
            try {
                for await (const event of getNookClient().search({ query: trimmed, limit }, controller.signal)) {
                    if (event.type === "done")
                        return setStatus("done");
                    // The first frame of a stream replaces the previous query's rows;
                    // later frames (a `vector` source, one day) merge in by nook ID.
                    const replace = first;
                    first = false;
                    setResults((current) => {
                        const base = replace ? [] : current;
                        const seen = new Set(base.map((nook) => nook.id));
                        return [...base, ...event.nooks.filter((nook) => !seen.has(nook.id))];
                    });
                }
                // A stream that ends without `done` failed after it opened.
                setStatus("error");
            }
            catch {
                if (!controller.signal.aborted)
                    setStatus("error");
            }
        }, DEBOUNCE_MS);
        return () => {
            clearTimeout(timer);
            controller.abort();
        };
    }, [query, limit]);
    return { results, status };
}
//# sourceMappingURL=use-search-stream.js.map